import { getPRPC } from "../../../hooks/usePRPC";
import createRPCQuery from "../../../utils/createRPCQuery.util";
import { decompressRoute } from "../../../utils/decompressRoute.util";

interface CallbackFunction {
	(data: any): void;
}

/** One more try after a failed route request (a map provider timeout). */
const RETRY_DELAY_MS = 1500;

const wait = (ms: number) =>
	new Promise((resolve) => {
		setTimeout(resolve, ms);
	});

export default function calcRoute(points: any[], callback: CallbackFunction) {
	return () => {
		const prpcow = getPRPC();

		if (!prpcow || !points?.length) return null;

		const request = () =>
			createRPCQuery(() => prpcow.theirsModel.map.route(points || []));

		// A failed request left no track and an uncaught error in the
		// console (dev check F8): retry once, then log and give up.
		return request()
			.catch(() => wait(RETRY_DELAY_MS).then(request))
			.then(decompressRoute)
			.then(callback)
			.catch((error) => {
				console.error("[calcRoute] route request failed", error);
				return null;
			});
	};
}
